import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-overview-step',
    templateUrl: './overview-step.component.html',
    styleUrls: ['./overview-step.component.scss'],
    standalone: false
})
export class OverviewStepComponent {
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  onNext(): void {
    this.next.emit();
  }

  onBack(): void {
    this.back.emit();
  }

  openWorksheet(): void {
    window.open('assets/worksheet/WorldTumbler_World_Building_Worksheet.html', '_blank');
  }
}
